import { AnswerSelectWithRadioProps } from '../AnswerSelectWithRadio';
import { FC, ReactElement } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

export interface AnswerSelectWithRadioContainerProps extends AnswerSelectWithRadioProps {
  children: (presentationState: AnswerSelectWithRadioPresentationProps) => ReactElement;
}

export interface AnswerSelectWithRadioPresentationProps {
  valueSonar: number | null | undefined;
  importance: number | undefined;
  labels: Record<string, string | undefined> | undefined;
  onSmileyPress: (index: number) => void;
  onImportanceChange: (value: number) => void;
}

const _Container: FC<AnswerSelectWithRadioContainerProps> = ({
  question,
  onNext,
  children,
}) => {
  const { treeNav, language } = useStores();
  const labels = language.translate.MOBILE?.SESSION;

  const valueSonar = treeNav.choices.pending?.valueSonar;
  const importance = treeNav.choices.pending?.importance;

  const handleSmileyPress = (index: number) => {
    const selectedValue = index + 1;
    treeNav.choices.updatePending({
      questionId: question._id,
      questionKey: question.key,
      valueSonar: selectedValue,
    });

    // Auto-advance if importance is already set
    const currentImportance = treeNav.choices.pending?.importance;
    if (currentImportance) {
      onNext?.();
    }
  };

  const handleImportanceChange = (value: number) => {
    treeNav.choices.updatePending({
      questionId: question._id,
      questionKey: question.key,
      importance: value,
    });

    // Auto-advance if valueSonar is already set
    const currentValueSonar = treeNav.choices.pending?.valueSonar;
    if (currentValueSonar) {
      onNext?.();
    }
  };

  return children({
    valueSonar,
    importance,
    labels,
    onSmileyPress: handleSmileyPress,
    onImportanceChange: handleImportanceChange,
  });
};

export const Container = observer(_Container);
